// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"155":"e72d100c","175":"b6a18576","610":"a8f4f79b"}[chunkId] + ".js";
};